// The fonts posts draw with: the email designer's set (so posts and emails
// match), plus a few only posts use, like the typewriter face on a review
// receipt. Kept here so the email designer's font list stays as it is.
import { FONTS, fontStack, googleFontsHref } from '../../email-composer/email/theme'

export const POST_FONTS = {
  courierPrime: { label: 'Courier Prime', kind: 'mono', stack: "'Courier Prime', 'Courier New', Courier, monospace", google: 'Courier+Prime:ital,wght@0,400;0,700' },
}

export const stackOf = (key) => (POST_FONTS[key] ? POST_FONTS[key].stack : fontStack(key))
export const fontLabel = (key) => ((POST_FONTS[key] || FONTS[key] || {}).label || key)

// One stylesheet link for every font asked for, from either set
export const fontsHref = (keys) => {
  const list = Array.from(new Set(keys.filter(Boolean)))
  const own = list.filter(k => POST_FONTS[k]).map(k => `family=${POST_FONTS[k].google}`)
  const shared = googleFontsHref(list.filter(k => !POST_FONTS[k]))
  if (!own.length) return shared
  if (!shared) return `https://fonts.googleapis.com/css2?${own.join('&')}&display=swap`
  return shared.replace('&display=swap', `&${own.join('&')}&display=swap`)
}
